import * as React from 'react';
import './index.scss';
import { Basics } from '@pubts/context.ts';
import { fetch, AreaInfo, HourChampionRsp, HourRankRsp, RichRankRsp, ContributeRsp, AuditionRankRsp, areaList } from '@pubts/fetch.ts';
import Rank1 from './rank1.tsx';
import Rank2 from './rank2.tsx';
// import Rank3 from './rank3.tsx';
import Rank4 from './rank4.tsx';
import Rank5 from './rank5.tsx';
import Rich from './rich.tsx';
import Hour from './hour.tsx';
import AnchorDetect from 'react-anchor-scroll-detect';
const { useEffect, useState, useContext } = React;
declare global {
  interface Window {
    $: any
  }
}
interface TabsType {
  current: number,
  title: string,
  time: string,
  tips: string,
}
interface Props {
  index: number,
}
const Tab1and2: React.FC<Props> = props => {
  const { iStage, tabToastOpen, current } = useContext(Basics);
  const [finalRank, FinalRank] = useState<any>([]);
  const [shenhaoRank, ShenhaoRank] = useState<any>([]);
  const [finalRankBefore, FinalRankBefore] = useState<any>([]);
  const [eliminationRank, EliminationRank] = useState<any>([]);
  const [resurgenceRank, ResurgenceRank] = useState<any>([]);
  const [auditionRank, AuditionRank] = useState<any>([]);
  const [contribute, Contribute] = useState<any>([]);
  const [iArea, Iarea] = useState<number>(1);
  // const [sideHeight, setSideHeight] = useState<number>(1);
  const [sMatchDesc, SMatchDesc] = useState<string>('');
  const [sMatchDescTt, SMatchDescTt] = useState<string>('');
  const [sMatchDescFh, SMatchDescFh] = useState<string>('');

  const [hourChampion, HourChampion] = useState<any>([]);
  const [hourData, HourData] = useState<any>([]);
  const [iHour, IHour] = useState<number>(1)

  const [showtab, SHOWTAB] = useState<boolean>(false);
  /* 防抖 */
  const debounce = (fn: any, wait: number) => {
    let timer: any = null;
    return function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        fn();
      }, wait);
    }
  }
  useEffect(() => {
    const req = {
      lPid: 0,
      iAreaId: iArea,
    }
    const rankReq = {
      lPid: 0,
      iAreaId: iArea,
      iStage: current,
    }
    // 海选赛
    if (current !== 2 && current !== 4) {
      fetch.getStageRank202108(
        rankReq
      ).then((rsp: AuditionRankRsp) => {
        console.log('海选赛 大区：', rankReq, rsp);
        AuditionRank(rsp.vItem.value);
        SMatchDesc(rsp.sMatchDesc)
        if (current === 3) {
          FinalRankBefore(rsp.vItem.value.slice(0, 3))
          FinalRank(rsp.vItem.value.slice(3));
          SMatchDesc(rsp.sMatchDesc)
        }
      })
    }
    // 淘汰赛
    if (current === 2) {
      fetch.getStageRank202108(
        {
          lPid: 0,
          iAreaId: iArea,
          iStage: current,
          iRevive: 1, // 1= 取复活赛，0= 淘汰赛 （此标记只有第二阶段才会用）
        },
      ).then((rsp: AuditionRankRsp) => {
        console.log('复活赛 大区：', rankReq, rsp);
        ResurgenceRank(rsp.vItem.value);
        SMatchDescFh(rsp.sMatchDesc)
      })
      fetch.getStageRank202108(
        {
          lPid: 0,
          iAreaId: iArea,
          iStage: current,
          iRevive: 0, // 1= 取复活赛，0= 淘汰赛 （此标记只有第二阶段才会用）
        },
      ).then((rsp: AuditionRankRsp) => {
        console.log('淘汰赛 大区：', rankReq, rsp);
        EliminationRank(rsp.vItem.value);
        SMatchDescTt(rsp.sMatchDesc)
      })
    }
    // 小时冠军榜
    fetch.getHourChampion202108(req).then((rsp: HourChampionRsp) => {
      console.log('小时冠军：', req, rsp);
      HourChampion(rsp.vItem.value)
    })
    // 小时榜
    fetch.getHourRank202108(req)
      .then((rsp: HourRankRsp) => {
        console.log('小时榜单', req, rsp);
        HourData(rsp.vItem.value)
        IHour(rsp.iHour)
      })

    // 神豪
    fetch.getRichRank202108(
      {
        lPid: 0,
      },
    )
      .then((rsp: RichRankRsp) => {
        console.log('神豪榜 大区：', rsp);
        ShenhaoRank(rsp.vItem.value)
      })

    // 车队
    fetch.getContribute202108({
      lPid: 0,
    }).then((rsp: ContributeRsp) => {
      console.log('车队贡献榜:', rsp)
      Contribute(rsp.vList.value)
    })
  }, [current, iArea])
  useEffect(() => {
    const isChrome = window.navigator.userAgent.indexOf('Chrome') > -1;
    // const canSet = window.innerHeight - 60;
    // if (canSet < 1100) {
    //   setSideHeight(canSet / 1100);
    // } else {
    //   setSideHeight(1);
    // }
    if (isChrome) {
      window.$(window).on('scroll', debounce(handleScroll, 300));
      window.$(window).on('resize', debounce(() => SHOWTAB(false), 300));
    }

  })
  const handleScroll = () => {
    const marginH = window.$(window).scrollTop();
    if (marginH >= 930 && document.body.offsetWidth > 1600) {
      SHOWTAB(true);
    }
    if (marginH <= 930 && document.body.offsetWidth > 1600) {
      SHOWTAB(false);
    }
  }

  // useEffect(() => {
  //   Current(iStage >= 4 ? 3 : iStage)
  // }, [iStage])
  return (
    <div className='tab1and2'>
      <div className={`tab1and2_nav nav${iArea}`}>
        <ul>
          {
            areaList.map((item: any, index: number) => (
              <li
                key={index}
                className={
                  iArea === item.iArea ? 'on ' + item.className + '-1' : item.className
                }
                onClick={
                  () => {
                    Iarea(item.iArea);
                  }
                }
              >
              </li>
            ))
          }
        </ul>
      </div>
      {/* {
        showtab &&
        <AnchorDetect
          className={"sideBar-1 sideBar"}
          items={[...areaList.map((item: AreaInfo) => ('area-' + item.iArea)), 'rich', 'top']}
          activeClass="active"
          offsetTop={150}
        >
          {
            areaList.map((item: AreaInfo, index: number) => (
              <li key={index}>
                {item.sAreaName}
              </li>
            ))
          }
          <li style={{ color: 'rgb(255, 239, 187)' }}>神豪榜</li>
          <li>TOP <i /></li>
        </AnchorDetect>
      } */}
      <div
        className='ranklist'
      >
        {
          current === 1 &&
          <Rank1 count={10} data={auditionRank} color={'#ffffff'} selectBackground={'#2582eb'} selectColor={'#ffffff'} sMatchDesc={sMatchDesc} />
        }
        {/* 淘汰 */}
        {
          current === 2 &&
          <><Rank2 count={10} data={eliminationRank} id="tt" color={'#ffffff'} selectBackground={'#2582eb'} selectColor={'#ffffff'} sMatchDescTt={sMatchDescTt} />
            <Rank2 count={10} data={resurgenceRank} id="fh" color={'#ffffff'} selectBackground={'#2582eb'} selectColor={'#ffffff'} sMatchDescFh={sMatchDescFh} /></>
        }

        {
          current === 3 &&
          <Rank4 count={7} data={finalRank} finalRankBefore={finalRankBefore} color={'#ffffff'} selectBackground={'#2582eb'} selectColor={'#ffffff'} />
        }
      </div>

      <Hour
        hourChampion={hourChampion}
        data={hourData}
        iHour={iHour}
        count={5}
        color={'#ffffff'} selectBackground={'#2582eb'} selectColor={'#ffffff'}
      />
      <Rank5 count={5} data={contribute} color={'#ffffff'} selectBackground={'#2582eb'} selectColor={'#ffffff'} />
      <Rich count={5} data={shenhaoRank} color={'#ffffff'} selectBackground={'#2582eb'} selectColor={'#ffffff'} />
    </div>
  )
}

export default Tab1and2;